angular.module('eficienciaFiscalModule')
    .directive('cbkSimpleTabs', ['$timeout', function ($timeout) {
        return {
            restrict: 'E',
            transclude: true,
            scope: {
                tabsLeft: '&'
            },
            template: '<div class="{{tabsLeft() ? \'tabs-left\' : \'\'}}">' +
            '   <ul class="nav nav-tabs bordered" style="border-right: 0; border-top: 0; {{tabsLeft() ? \'border-bottom: 0\' : \'border-left: 0\'}}">' +
            '       <li ng-repeat="tab in tabs" ng-if="tab.if == undefined || tab.if" class="{{tab.active ? \'active\' : \'\'}}">' +
            '           <a href="javascript:void(0)" ng-click="selectTab(tab)">{{tab.label}}</a>' +
            '       </li>' +
            '   </ul>' +
            '   <div class="tab-content" style="padding: 13px;" ng-transclude></div>' +
            '</div>',
            controller: ['$scope', function ($scope) {
                this.addTab = function (tab) {
                    if ($scope.tabs == undefined) {
                        $scope.tabs = [];
                        this.selectTab(tab);
                    }

                    $scope.tabs.push(tab)
                }

                this.selectTab = function (tab) {
                    angular.forEach($scope.tabs, function (tab) {
                        tab.active = false;
                    });
                    tab.active = true;
                }
            }],
            link: function (scope, elm, attrs, tabsCtrl) {
                scope.selectTab = tabsCtrl.selectTab;
            }
        };
    }])

    .directive('cbkSimpleTabsPane', [function () {

        return {
            restrict: 'E',
            require: '^?cbkSimpleTabs',
            transclude: true,
            scope: {label: '@'},
            template: '<div ng-show="active" class="tab-pane{{active ? \' active\' : \'\'}}" ng-transclude></div>',
            link: function (scope, elm, attrs, cbkTabsCtrl) {
                if (cbkTabsCtrl)
                    cbkTabsCtrl.addTab(scope);
            }
        };
    }]);
